import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=e608721a&"
import script from "./Deny.vue?vue&type=script&lang=js&"
export * from "./Deny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports